import { __assign } from "tslib";
import { MobileScrollActionTypes } from './actions';
export default function (state, action) {
    switch (action.type) {
        case MobileScrollActionTypes.SET_KEYBOARD_HEIGHT:
            return __assign(__assign({}, state), { keyboardHeight: action.keyboardHeight });
        case MobileScrollActionTypes.SET_HEIGHT_DIFF:
            return __assign(__assign({}, state), { heightDiff: action.heightDiff });
        case MobileScrollActionTypes.SET_WINDOW_HEIGHT:
            return __assign(__assign({}, state), { windowHeight: action.windowHeight });
    }
    return state;
}
//# sourceMappingURL=reducer.js.map